// extracted by mini-css-extract-plugin
export var heading = "blog-module--heading--RMkP2";
export var headingContainer = "blog-module--heading-container--26L9H";
export var layout = "blog-module--layout--u4LH1";
export var list = "blog-module--list--vfzQm";
export var subheading = "blog-module--subheading--0iAZL";
export var tagsBox = "blog-module--tags-box--mWNBY";